module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_message-9d4f2f7ce9c263adb11689e85e68bb61.svg";